export default "__VITE_ASSET__Bu0eu5m___"